import {observer} from 'mobx-react-lite';
import * as React from 'react';
import {FunctionComponent} from 'react';

export interface FormCheckboxProps {
    checked: boolean;
    help?: string;
    id: string,
    label: any;
    name: string;
    onChange: (v: boolean) => void;
    required?: boolean;
}

export const FormCheckbox: FunctionComponent<FormCheckboxProps> = observer((p) =>
    <div className="form-check">
        <div className="form-check-input-wrapper">
            <input
                type="checkbox"
                className="form-check-input"
                checked={p.checked}
                name={p.name}
                onChange={(e) => p.onChange(e.target.checked)}
                required={p.required}
            />
            <svg className={'form-check-tick'} viewBox="0 0 20 20">
                <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
            </svg>
        </div>
        <div>
            <label
                className="form-check-label"
                htmlFor={p.id}>
                {p.label}
            </label>
            {p.help && <p className="input-hint mt-0">{p.help}</p>}
        </div>
    </div>
);
